import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { useTheme } from 'next-themes'
import React, { useCallback } from 'react'

import { DialogTitle } from '@/components/ui/dialog'

import { PreferencesSectionContainer } from '../preferences-section-container'

const AccountTheme = () => {
  const { theme, setTheme } = useTheme()
  const t = useTranslations('Settings.accounts')
  const themes = [
    { name: 'Light', value: 'light', image: '/img/themes/light.png' },
    { name: 'Dark', value: 'dark', image: '/img/themes/dark.png' },
    { name: 'System', value: 'system', image: '/img/themes/system.png' },
  ]

  const getThemeNameLocalization = useCallback(
    (theme: string) => {
      switch (theme) {
        case 'light':
          return t('theme.light')
        case 'dark':
          return t('theme.dark')
        case 'system':
          return t('theme.system')
        default:
          return ''
      }
    },
    [t],
  )

  return (
    <PreferencesSectionContainer>
      <div className="flex flex-col gap-1.5">
        <DialogTitle className="text-base font-semibold">{t('theme.title')}</DialogTitle>
        <p className="text-sm font-normal text-muted-foreground">{t('theme.subTitle')}</p>
      </div>
      <div className="flex flex-col gap-2">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
          {themes.map((themeOption) => (
            <div key={themeOption.name} className="flex flex-col gap-2">
              <input
                type="radio"
                id={themeOption.name}
                name="theme"
                value={themeOption.value}
                checked={theme === themeOption.value}
                onChange={(e) => setTheme(e.target.value)}
                className="peer sr-only"
              />
              <label
                htmlFor={themeOption.name}
                className={`flex h-[90px] w-[140px] cursor-pointer flex-col items-start justify-between overflow-hidden rounded-xl
                    ${theme === themeOption.value ? 'border border-base-primary' : 'border border-base-border'}`}
              >
                <div className="relative h-full w-full">
                  <Image
                    src={themeOption.image}
                    alt={`${themeOption.name} theme preview`}
                    fill
                    sizes="(max-width: 768px) 100px, 140px"
                    className="object-cover"
                  />
                </div>
              </label>
              <span className="text-sm font-normal text-muted-foreground">
                {getThemeNameLocalization(themeOption.value) || themeOption.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </PreferencesSectionContainer>
  )
}

export default AccountTheme
